import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button } from '@shopify/polaris'

import { SHOPIFY_GRAY } from 'components/styles'
import Text from 'components/common/Text'
import pic from 'assets/shopify_empty_scene.png'

const Wrapper = styled.div`
  height: 25.6em;
  width: 14.4em;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: ${SHOPIFY_GRAY};
  border: 2px gray dashed;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 2em;
`
const Header = styled.div`
  margin-left: 1em;
  margin-top: 5em;
`
const Desc = styled.div`
  margin-left: 1em;
  margin-top: 1em;
`
const ButtonContainer = styled.div`
  margin-left: 1em;
  margin-top: 2.6em;
  & > * {
    font-size: 0.7em;
  }
`
const Image = styled.div`
  background-image: url('${pic}');
  background-repeat: no-repeat;
  background-size: contain;
  width: 10em;
  height: 10em;
  margin-left: 4em;
  margin-top: 2em;
  z-index: 1;
`

class EmptyProductSceneCard extends Component {
  render () {
    const { onClick, noScenesYet } = this.props
    const headerText = noScenesYet ? 'Add a product scene' : 'Add another product scene'
    return (
      <Wrapper onClick={onClick} >
        <Header>
          <Text color='#212b36' styleRaw='font-weight: 600'>{headerText}</Text>
        </Header>
        <Desc>
          <Text size='medium'>Just select 1-2 products</Text>
        </Desc>
        <ButtonContainer>
          <Button primary size='slim'>Add products</Button>
        </ButtonContainer>
        <Image />
      </Wrapper>
    )
  }
}


EmptyProductSceneCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  noScenesYet: PropTypes.bool
}

export default connect()(EmptyProductSceneCard)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyScenesDashboard/EmptyProductSceneCard.js